/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{9AFEC168-FA25-4739-88D7-C1493894E46A}",
  "sitecoreApiHost": "https://qa.dayross.com/",
  "jssAppName": "internet",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/internet",
  "graphQLEndpoint": "https://qa.dayross.com//api/internet?sc_apikey={9AFEC168-FA25-4739-88D7-C1493894E46A}"
};